import { Tooltip as MantineTooltip, type TooltipProps } from "@mantine/core";
import type { ReactNode } from "react";

type NativeLikeTooltipProps = Omit<TooltipProps, "children"> & {
	children: ReactNode;
};

export function NativeLikeTooltip({
	children,
	position = "bottom",
	offset = 6,
	openDelay: _openDelay,
	transitionProps: _transitionProps,
	withArrow: _withArrow,
	arrowSize: _arrowSize,
	arrowOffset: _arrowOffset,
	radius: _radius,
	color: _color,
	zIndex: _zIndex,
	styles: _styles,
	...props
}: NativeLikeTooltipProps) {
	return (
		<MantineTooltip
			{...props}
			openDelay={100}
			position={position}
			offset={offset}
			transitionProps={{ duration: 80, transition: "fade" }}
			zIndex={9999}
			withArrow={false}
			styles={{
				tooltip: {
					backgroundColor:
						"color-mix(in srgb, var(--ui-color-surface-default) 96%, transparent)",
					backdropFilter: "blur(10px)",
					color: "var(--ui-color-text-tertiary)",
					border: "1px solid var(--ui-color-border-subtle)",
					boxShadow:
						"0 10px 30px color-mix(in srgb, var(--ui-color-text-primary) 12%, transparent)",
					fontSize: "12px",
					fontWeight: 500,
					lineHeight: 1.2,
					letterSpacing: "0.01em",
					padding: "7px 10px",
					borderRadius: "8px",
				},
			}}
		>
			{children}
		</MantineTooltip>
	);
}
